import { Loader } from 'components/Loader';
import type { Crm } from 'domain/crm';
import { CrmDisplayName } from 'domain/crm';
import { translate } from 'services/i18n';

import { StyledBulkText, StyledPreviewLoader } from './styles';

export const PreviewLoadingState = ({ crm }: { crm: Crm }) => (
  <>
    <StyledBulkText>
      {translate('contacts.bulk.export_to_crm.preview_modal.subtitle.loading', {
        crm: CrmDisplayName[crm],
      })}
    </StyledBulkText>
    <StyledPreviewLoader>
      <Loader size={46} borderWidth={4.5} />
    </StyledPreviewLoader>
  </>
);
